<template>
  <div
    class="
      layout/grid:2
      @768/layout/border:3pt
      @768/layout/flex
      layout/border:2pt
      layout/width:100%
      @480/layout/width:clear
      "
      >
      <sortButton
        :highlighted="!isRandom"
        :label="otherSort"
        gtm="artists / logical sort"
        @sort="$emit('sort', -10)"
      />
      <sortButton
        :highlighted="isRandom"
        :label="randomSortLabel"
        gtm="artists / random sort"
        @sort="$emit('sort', (Math.random() * 2 - 1))"
      />
  </div>
</template>

<script>
  import i18n from '../../utils/i18n.js';
  import sortButton from './button.vue';

  export default {
    components: {
      sortButton
    },

    props: {
      random: { type: Number, required: false, default: -10 },
      searchVal: {type: String, required: false, default: "" },
    },

    data: function() {
      return {
        i18n: new i18n(),
      };
    },

    computed: {
      isRandom(){
        return this.random != null && this.random >= -1 && this.random <= 1;
      },
      randomSortLabel() {
        return this.i18n.t('collection__artists__index__random-sort');
      },
      otherSort() {
        if (this.searchVal == null || this.searchVal == "") {
          return "A&ndash;Z";
        }
        return this.i18n.t('collection__artists__index__relevant-sort');
      }
    },
  };
</script>
